import React from 'react';
import { Card } from "react-bootstrap";
import faceAttilaKovacs from "../../assets/img/faceAttilaKovacs.jpg";
import ShowMoreText from "react-show-more-text";
import projKovacsA_politics from "../../assets/img/projKovacsA_politics.png";

const Attila_Kovacs_politics = () => {
    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>Psychological characteristics behind (academic) performance</h2></Card.Title> */}

        <Card.Img variant="top" src={projKovacsA_politics} />
        <br />
        <Card.Body>
          <Card.Text className="ct1">
            {" "}
            <img
              className="img2"
              src={faceAttilaKovacs}
            />{" "}
            <p className="text7">Attila Kovács</p>
            <br />
            <p className="text8">
              Founder & CEO{" "}
            </p>
            <p className="text8">Eulytix </p>
          </Card.Text>
          <ShowMoreText lines={1}>
            <div>
            Legislative data offers critical insights into the influence and effectiveness of political actors. In both 
            the European Union and Ukraine, legislation directly shapes governance and citizens’ lives, while geopolitical 
            tensions—particularly Russia’s aggression against Ukraine—underscore the need for systematic analysis. This 
            project employs textual data such as speeches, statements, legislative initiatives, and amendments to map policy 
            positions and assess their relationship to legislative success in the European Parliament and the Rada. It further 
            examines the determinants of effectiveness, including amendment and voting outcomes, network centrality, and 
            ideological alignment. Special attention is given to pro-European and pro-Russian divisions in the Rada. Through 
            comparative study, the research advances understanding of how political positions and institutional dynamics shape 
            democratic outcomes in Europe.

            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
};

export default Attila_Kovacs_politics;